import React, { useContext, useState } from "react";
import { SearchBox } from "../../../common/SearchBox";
import { SearchBoxWrapper } from "../MessagePanel.style";
import {
  IUserInfo,
  IVisibleTo,
  searchUsersByName,
  sortRecipientsByNameAlphabetically,
} from "@home-health-notify/domain";
import { UserDirectoryContext, useTranslation } from "hhn-commons";

const MessageDetailSearchBox = ({
  showSearch,
  recipients,
  setFilteredRecipientList,
}: {
  showSearch: boolean;
  recipients: IVisibleTo[];
  setFilteredRecipientList: (list: IVisibleTo[]) => void;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const { userDirectory } = useContext(UserDirectoryContext);
  const [searchText, setSearchText] = useState<string>("");

  const onSearchClear = () => {
    setSearchText("");
    setFilteredRecipientList(
      sortRecipientsByNameAlphabetically(recipients, userDirectory),
    );
  };

  const onSearchTextChange = (text: string) => {
    setSearchText(text);
    const recipientsUserInfo = recipients.map((recipientItem: IVisibleTo) => {
      return userDirectory.getUserInfo(recipientItem.id);
    });
    const filteredUsers = searchUsersByName(text, recipientsUserInfo);
    const filteredUsersById = filteredUsers.map(
      (filteredUser: IUserInfo) => filteredUser.id,
    );
    const filteredRecipientItem = recipients.filter(
      (recipientItem: IVisibleTo) =>
        filteredUsersById.includes(recipientItem.id),
    );
    if (text === "") {
      setFilteredRecipientList(
        sortRecipientsByNameAlphabetically(recipients, userDirectory),
      );
      return;
    }
    setFilteredRecipientList(filteredRecipientItem);
  };

  return (
    <SearchBoxWrapper>
      {showSearch && (
        <SearchBox
          placeholderLabel={tNs("search")}
          searchText={searchText}
          onSearchTextChange={onSearchTextChange}
          onSearchClear={onSearchClear}
          autoFocus
        />
      )}
    </SearchBoxWrapper>
  );
};

export default MessageDetailSearchBox;
